type AsDict<T> = T & Record<string, T[keyof T]>;

export default function asDict<T>(t: T): AsDict<T> {
    return t as AsDict<T>;
}
